// AUTO-GENERATED from /app/docs/legal/01_TERMOS_DE_USO.md. Do not edit by hand.
export default `# Termos de Uso — BlueGov

**Versão 1.0 · Vigência: a partir de Fevereiro/2026**

## 1. Objeto
Estes Termos regem o uso da plataforma **BlueGov — Plataforma de Conformidade e Proteção Institucional (PCPI)**, oferecida pela BlueGov Tecnologia (denominada "**BlueGov**") a órgãos públicos contratantes (denominados "**Órgão Contratante**") e seus usuários autorizados.

## 2. Finalidade do Sistema
O BlueGov é uma plataforma SaaS multi-tenant destinada a centralizar, organizar, monitorar e demonstrar o cumprimento de **Atos de Controle** (determinações, recomendações, auditorias, diligências, TACs, ACPs e demais documentos emitidos por TCEs, TCU, CGU, MP ou auditoria interna), bem como prover trilhas verificáveis (Hash Chain SHA-256), Dossiês Executivos, Inteligência de Risco, IPI (Índice de Proteção Institucional), Visão Executiva e Auditor Externo somente-leitura.

## 3. Perfis de Acesso
O sistema opera com controle de acesso baseado em papéis (RBAC). Cada usuário recebe um perfil entre: \`SUPER_ADMIN\`, \`ADMIN_ESTADUAL\`, \`CGE\`, \`CONTROLE_INTERNO\`, \`AUDITORIA\`, \`CASA_CIVIL\`, \`JURIDICO\`, \`SECRETARIA_EXECUTORA\`, \`UNIDADE_INTERNA\`, \`GOVERNADOR\`, \`OBSERVADOR_EXTERNO\`, \`AUDITOR_EXTERNO\`. As permissões de cada perfil estão descritas no Manual Operacional vigente da plataforma.

## 4. Responsabilidades

### 4.1 Do Usuário
- Manter sigilo absoluto das credenciais (senha local OU sessão Microsoft Entra ID).
- Não compartilhar acesso, tokens, PINs de Auditor Externo ou URLs de verificação contendo dados sigilosos.
- Utilizar o sistema exclusivamente para finalidades institucionais.
- Manter atualizadas as informações cadastrais.

### 4.2 Do Órgão Contratante
- Cadastrar e descadastrar usuários conforme rotatividade de servidores.
- Definir corretamente o perfil RBAC de cada usuário.
- Configurar (quando aplicável) Microsoft Entra ID, SendGrid, integrações SEI etc.
- Garantir a base legal LGPD do tratamento dos dados que insere na plataforma.
- Atuar como **Controlador** dos dados pessoais (art. 5º, VI, LGPD).

### 4.3 Da BlueGov
- Manter a plataforma operacional em regime de melhor esforço.
- Aplicar atualizações de segurança e correções.
- Atuar como **Operador** dos dados pessoais (art. 5º, VII, LGPD), nos termos do Acordo de Processamento de Dados (DPA) firmado.
- Prover registros de auditoria imutáveis (Hash Chain SHA-256).
- Notificar o Órgão Contratante em caso de incidente de segurança em até 24h da ciência.

## 5. Regras de Utilização
- É proibido: tentar burlar mecanismos de auditoria, alterar logs, executar engenharia reversa, scrapear em massa, sobrecarregar APIs, distribuir conteúdo proprietário.
- Toda interação relevante gera evento na trilha de auditoria com hash criptográfico.
- Comportamentos abusivos podem levar à suspensão imediata, com notificação ao Órgão Contratante.

## 6. Auditoria e Rastreabilidade
Todas as ações realizadas na plataforma são registradas em \`audit_logs\` com encadeamento criptográfico SHA-256 (Hash Chain). Os registros incluem: identificação do usuário, perfil, IP, ação, entidade afetada, estado anterior e novo, timestamp, hash anterior e hash atual. O Órgão Contratante e Auditores Externos autorizados podem verificar a integridade da cadeia a qualquer momento via \`Verificar Integridade da Auditoria\`.

## 7. Disponibilidade
O BlueGov opera em regime de melhor esforço, sem SLA contratual de uptime garantido neste momento. Monitoramento disponível em \`/health\` para o Órgão Contratante.

## 8. Limitação de Responsabilidade
- A BlueGov **não responde** por: (i) decisões tomadas pelo gestor com base em sugestões de IA; (ii) dados inseridos incorretamente por usuários; (iii) atrasos derivados de instabilidade de serviços externos (Microsoft, MongoDB Atlas, IBGE, Emergent LLM, Railway); (iv) uso indevido de credenciais por terceiros não autorizados; (v) descumprimento dos prazos pelo Órgão Contratante.
- A IA presente na plataforma **sugere** classificações, pareceres e resumos; a decisão final é sempre do servidor responsável.

## 9. Atualizações
A BlueGov pode atualizar, modificar ou suspender funcionalidades a qualquer momento, sem aviso prévio quando se tratar de correções de segurança. Mudanças significativas no produto serão comunicadas ao Órgão Contratante.

## 10. Propriedade Intelectual
- O software, marca "BlueGov", logotipo, layout e algoritmos (IPI, Hash Chain, Risk Intelligence, Wizard de 8 passos, Dossiê Executivo, Verificação Pública, Auditor Externo) são de propriedade exclusiva da BlueGov.
- Dados inseridos pelo Órgão Contratante permanecem de sua titularidade.
- É vedada qualquer reprodução, distribuição ou criação de obras derivadas sem autorização escrita.

## 11. Suspensão e Encerramento
A BlueGov pode suspender o acesso de usuário individual em caso de uso indevido ou risco de segurança, com notificação ao Órgão Contratante. O encerramento contratual segue o instrumento firmado entre as partes; após o término, os dados são entregues em formato exportável e excluídos após o prazo de retenção definido (item 13 da Política de Privacidade).

## 12. Foro e Legislação Aplicável
Estes Termos são regidos pela legislação brasileira (Constituição Federal, Código Civil, Lei 13.709/2018 — LGPD, Lei 12.527/2011 — LAI, Lei 14.133/2021 e demais normas aplicáveis). Fica eleito o foro do Órgão Contratante, ou subsidiariamente o da sede da BlueGov, para dirimir controvérsias.

---
**Contato:** dpo@bluegov.com.br
`;
